export default __webpack_public_path__ + "static/media/openOrderGif2.b925708f.gif";